import {useRef, useState} from 'react';

import {colors} from 'shells/colors/colors';
import {TextRegularAiIcon} from 'shells/icon';
import {Stack} from 'shells/layout/stack/stack';
import {Popover} from 'shells/popover/popover';
import {Body} from 'shells/typography/body';

import styles from './thread-summary.module.css';

interface Props {
    summary: string;
    shouldTruncateSummary?: boolean;
}

export function ThreadSummary(props: Props) {
    const {shouldTruncateSummary = true} = props;

    const [isHovered, setIsHovered] = useState(false);
    const containerRef = useRef<HTMLDivElement>(null);

    return (
        <div
            ref={containerRef}
            className={`border pad-12 br-8 my-12 mx-16 ${
                shouldTruncateSummary ? 'pointer-cursor' : ''
            }`}
            onMouseEnter={shouldTruncateSummary ? () => setIsHovered(true) : undefined}
            onMouseLeave={shouldTruncateSummary ? () => setIsHovered(false) : undefined}
        >
            <Stack isHorizontal={true} spacing={4}>
                <TextRegularAiIcon
                    // @ts-expect-error
                    color={colors.aiPurplePrimary}
                    size={16}
                />
                {shouldTruncateSummary ? (
                    <Body size='small' truncate={{type: 'block', maxLines: 2}}>
                        {props.summary}
                    </Body>
                ) : (
                    <Body size='small'>{props.summary}</Body>
                )}
            </Stack>
            {shouldTruncateSummary && isHovered && (
                <Popover anchor={containerRef.current} location='bottom' bodyColor='dark'>
                    <div className={styles['popover-container']}>{props.summary}</div>
                </Popover>
            )}
        </div>
    );
}
